import React, { useEffect } from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AOS from "aos";
import "aos/dist/aos.css";
import ListItemIcon from "@mui/material/ListItemIcon";
import List from "@mui/icons-material/Grading";
import Com from "@mui/icons-material/ConnectWithoutContact";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import BorderClearIcon from "@mui/icons-material/BorderClear";
import NavPc from "./navPcEn";
import { Helmet } from "react-helmet";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';




const text = [
  {
  logo: "/clients/MakłowicziSynowielogo.webp",
  company: "Makłowicz i Synowie sp. z o.o.",
  description: "A joint business venture of the Makłowicz family and FoodHub S.A. (formerly Pamapol S.A.). A dynamically growing company in the FMCG sector, engaged in the production and distribution of food products in both domestic and international markets. Part of the FoodHub Capital Group.",
  linkwww: "https://maklowiczisynowie.pl/"
},
{
  logo: "/clients/ajde_logo.webp",
  company: "Ajde! Robert Makłowicz",
  description: "An e-commerce platform primarily focused on selling books authored by Mr. Robert Makłowicz and clothing branded with his persona.",
  linkwww: "https://maklowicz.sklep.pl/"
},
{
  logo: "",
  company: "Propinquus sp. z o.o",
  description: "A family-owned company with shareholders from the Makłowicz family. An investment and operational entity, particularly involved in managing image rights and coordinating business partnerships and contacts.",
  linkwww: "https://www.maklowicz.pl/"
},
{
  logo: "/clients/Bugenvillalogo.webp",
  company: "BugenVilla / Nada 22 d.o.o.",
  description: "A development company operating in Croatia. Handles the entire investment process: from finding and acquiring a suitable plot, to project design, obtaining permits, construction, and finally property sales. The company offers both luxury villas and apartments.",
  linkwww: "https://bugenvilla.com/"
},
{
  logo: "/clients/grupaforma.webp",
  company: "Grupa Forma (Forma Szultk Oskar Paw Jakub sp.k.)",
  description: "For more than 30 years, a leading provider of comprehensive commercial interior solutions. The company operates internationally and boasts an impressive portfolio of projects completed for major businesses, both in Poland and abroad.",
  linkwww: "https://www.grupaforma.com/"
},
{
  logo: "/clients/CHDLOGO.png",
  company: "Choluj Design s.c.",
  description: "A company operating in property management and architectural design. Offers services in architectural design, interior architecture, lighting, furniture, animation, visualizations, and 3D modeling.",
  linkwww: "https://cholujdesign.com/"
},


];

function PricingContent() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  return (

    <React.Fragment>
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
      <CssBaseline />
      {/* Hero unit */}
      <main>
        <NavPc />

        {/* wyjustowac od po czlaej szerokosci, dac ikonki na czarno  */}
        <Container justify="center" maxWidth="sm">
          <br /><br /><br /><br />
          {text.map((card) => (
            <Card data-aos="fade-right" variant="" maxWidth="sm">
              <CardMedia

              />
             <a href={card.linkwww} target="__blank" rel="noopener noreferrer">
                <img src={card.logo} width={300} />
              </a>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {card.company}

                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {card.description}
                </Typography>
          

                
              </CardContent>
              <CardActions>
                <a href={card.linkwww} target="__blank" rel="noopener noreferrer">
                {card.linkwww}
              </a>
              </CardActions>
              <hr />
              <br /><br />
            </Card>

          ))}
        <br /><br />
          <br /><br />



          <Helmet>
            <title>Clients</title>
            <meta name="description" content="Clients" />
            <link
              rel="canonical"
              href="http://kmtlegal.pl/Clients"
            />
          </Helmet>
        </Container>
      </main>
    </React.Fragment>
  );
}

export default function Pricing() {
  return <PricingContent />;
}
